import React from "react";
import { useTranslation } from "react-i18next";
import {Link} from "react-router-dom";
import {KEYWORDS_URL_QUERY_PARAMETER, RESOURCE_URL_QUERY_PARAMETER, INPUT_FORM_SUBMIT_ACTION} from '../constants/Query'

export function HomeNavigation() {
  const { t } = useTranslation();
  const navs = [
    {id: 'news',title: t('nav.news')},
    {id: 'blogs',title: t('nav.blogs')},
    {id: 'videos',title: t('nav.videos')},
    {id: 'podcasts',title: t('nav.podcasts')},
    {id: 'books',title: t('nav.books')},
  ]
  return (
    <nav role="navigation" aria-label="Page navigation">
      <ul className="no-bullet">
        {
          navs.map(nav =>(
            <li>
              <Link className="fz14 link" to={`${INPUT_FORM_SUBMIT_ACTION}?${RESOURCE_URL_QUERY_PARAMETER}=${nav.id}`} >{nav.title}</Link>
            </li>
          )).reduce((prev, curr) => [prev, <span>&nbsp;</span>, curr])
        }
      </ul>
    </nav>
  );
}

export function SearchNavigation({resource, initQuery, handleNavLinkClick}) {
  const { t } = useTranslation();
  let navs = []
  if (process.env.REACT_APP_DEFAULT_LOCALE === "ko"){
    navs = [
      {id: 'web',title: t('nav.web')},
      {id: 'news',title: t('nav.news')},
      {id: 'blogs',title: t('nav.blogs')},
      {id: 'videos',title: t('nav.videos')},
      {id: 'podcasts',title: t('nav.podcasts')},
    ]
  } else if (process.env.REACT_APP_DEFAULT_LOCALE === "pt"){
    navs = [
      {id: 'web',title: t('nav.web')},
      {id: 'news',title: t('nav.news')},
      {id: 'blogs',title: t('nav.blogs')},
      {id: 'videos',title: t('nav.videos')},
      {id: 'podcasts',title: t('nav.podcasts')},
    ]
  }else {
    navs = [
      {id: 'web',title: t('nav.web')},
      {id: 'blogs',title: t('nav.blogs')},
      {id: 'news',title: t('nav.news')},      
      {id: 'videos',title: t('nav.videos')},
      {id: 'podcasts',title: t('nav.podcasts')},
      {id: 'books',title: t('nav.books')},
    ]
  }
  
  return (
    <nav className="header-nav" role="navigation" aria-label="Search Navigation">
      <ul className="no-bullet">
      {
        navs.map(nav =>(
          <li key={nav.id}>
              <a id={nav.id} aria-selected={resource === nav.id? "true": "false"} href={`${INPUT_FORM_SUBMIT_ACTION}?${KEYWORDS_URL_QUERY_PARAMETER}=${initQuery}&${RESOURCE_URL_QUERY_PARAMETER}=${nav.id}`}>{nav.title}</a>
          </li>
        ))
      }
      </ul>
    </nav>
  );
}

